import * as THREE from "three";
import { useThree } from "@react-three/fiber";
import { RapierRigidBody, RigidBody } from "@react-three/rapier";
import { useRef, useMemo, useState, useEffect, useCallback } from "react";

export default function ShotCube() {
  const { camera } = useThree();
  const [cubeMesh, setCubeMesh] = useState([]);
  const cubeRef = useRef();

  const direction = useMemo(() => new THREE.Vector3(), []);
  const shootingEnabled = false; // disable cube shooting on click

  const clickToCreateBox = useCallback(() => {
    if (!shootingEnabled || !document.pointerLockElement) return;

    const newMesh = (
      <mesh
        position={[camera.position.x, camera.position.y - 0.5, camera.position.z]}
        castShadow
        receiveShadow
      >
        <boxGeometry args={[0.5, 0.5, 0.5]} />
        <meshStandardMaterial color="orange" />
      </mesh>
    );
    setCubeMesh((prevMeshes) => [...prevMeshes, newMesh]);
  }, [camera, shootingEnabled]);

  useEffect(() => {
    camera.getWorldDirection(direction);
    if (cubeMesh.length > 0) {
      cubeRef.current?.setLinvel(
        new THREE.Vector3(
          direction.x * 20,
          direction.y * 20 + 2,
          direction.z * 20
        ),
        false
      );
    }
  }, [cubeMesh]);

  useEffect(() => {
    if (!shootingEnabled) return undefined;

    const handleClick = () => clickToCreateBox();
    window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, [clickToCreateBox, shootingEnabled]);

  return (
    <>
      {cubeMesh.map((item, i) => {
        return (
          <RigidBody key={i} mass={0.6} ref={cubeRef}>
            {item}
          </RigidBody>
        );
      })}
    </>
  );
}
